import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ApiService } from '@angular/synthrone-design/services';
import { Observable } from 'rxjs/Rx';
import { ErrorComponent } from '@angular/synthrone-design/components';
import { environment } from '@synthroneEnvironments/environment';
import { NotificationBarModel } from '@synthroneApp/models/notification-bar/notification-bar.model';

@Component({
  selector: 'app-notification-bar-editor',
  templateUrl: './notification-bar-editor.component.html',
  styleUrls: ['./notification-bar-editor.component.scss']
})
export class NotificationBarEditorComponent {

  submitClicked: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected api: ApiService,
    public dialogRef: MatDialogRef<NotificationBarEditorComponent>,
    public dialog: MatDialog) { }


  onButtonClick = (param: 'close' | { mode: 'create' | 'preview', data: NotificationBarModel }): void => {
    if (param === 'close') {
      this.closeWindow(param);
      return;
    }

    const notificationData = param.data;

    delete notificationData.client;
    delete notificationData.app;

    this.submitClicked = true;
    this.api.patchData(`/notification-bar/${notificationData.key}`, notificationData, environment.api['notifications'].host).catch((error: any) => {
      this.submitClicked = false;
      this.showError(error);
      return Observable.throw(error)
    }
    ).subscribe((response) => {
      this.closeWindow(param);
    });
  };

  closeWindow = (param = null): void => {
    this.dialogRef.close(param);
  }

  showError = (message: string): Observable<any> => {
    let dialogRef = this.dialog.open(ErrorComponent, {
      data: {
        message: message
      }
    });
    return dialogRef.afterClosed();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/notification-bar-editor/notification-bar-editor.component.ts